import React, { FC } from 'react';
import { Box, Container, makeStyles, Theme, Typography } from '@material-ui/core';
import { ImageContent } from 'components/structures/general';
import { slide1 } from 'images/main';
import { demandResponseImage, evApartmentsImage, evCarsChargingImage, evManChargingImage } from 'images/us-energy-solutions';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(8),
    },
  },
  rootTitle: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(-1),
    },
  },
}));

const ListServices: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container maxWidth={false} fixed>
        <Typography variant="h1" className={classes.rootTitle} align="center">
          A comprehensive <br /> list of services:
        </Typography>
      </Container>
      <ImageContent
        imageMain={{ image: slide1 }}
        content={{
          title: 'Retail Energy',
          image: evApartmentsImage,
          text: 'US Energy Solutions helps the energy consumers find the best rates, manage risks to their investments and customize their energy procurement solutions to give them complete freedom in choosing the suppliers and services they require. Strategic insight, energy performance, and highly competitive pricing will affect how and where people procure energy.',
          link: { text: 'Give it a go', href: 'https://usenergysolutions.us/retail-energy' },
        }}
      />
      <ImageContent
        imageMain={{ image: evManChargingImage }}
        align="right"
        content={{
          title: 'EV Charging',
          image: evCarsChargingImage,
          text: 'The continuous growth of electric vehicle sales will provoke an expansion of the charging station networks as well. Therefore it is imperative to provide potential customers with a fast and convenient way to charge their vehicles close to the office/retail outlet/place of business. US Energy Solutions is a one-stop-shop for EV charging station installation.',
          link: { text: 'Give it a go', href: 'https://usenergysolutions.us/ev-charging' },
        }}
      />
      <ImageContent
        imageMain={{ image: demandResponseImage }}
        contentGridLg={5}
        content={{
          title: 'Demand Response',
          text: 'US Energy Solutions will determine where and how commercial users can reduce electricity consumption and facilitate agreements between consumers and utility companies. In return for participating in a demand response program, consumers will benefit from more favorable power rates and other valuable incentives.',
          link: { text: 'Give it a go', href: 'https://usenergysolutions.us/demand-response' },
        }}
      />
    </Box>
  );
};

export default ListServices;
